module.exports = __webpack_public_path__ + "static/media/Reciprocity Effect.36a2707e.jpg";